import { render, staticRenderFns } from "./NomenclaturesTab.vue?vue&type=template&id=f7f57ce6"
import script from "./NomenclaturesTab.vue?vue&type=script&lang=ts"
export * from "./NomenclaturesTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports